import mitt from 'mitt'

/**
 * 全局信号发送接收器
 */
export const emitter = mitt();

/**
 * 解绑监听时注意：
 * ⚠️ emitter.off(EMITTER_TYPE.WORKFLOW_UPDATE); 这种调用形式会取消所有该类型事件的监听器，可能会误删其他组件的监听
 * ✅ emitter.off(EMITTER_TYPE.WORKFLOW_UPDATE, handleWorkflowUpdate); 这种形式只会移除相同引用的handleWorkflowUpdate
 */

/**
 * 信号类型
 */
export const EMITTER_TYPE = {
    WS: "WS",
    WORKFLOW_UPDATE: 'WORKFLOW_UPDATE',
    NOTICE_TODO_UPDATE: 'NOTICE_TODO_UPDATE',
    SEND_RECORD_FINISH: 'SEND_RECORD_FINISH',
    NOTICE_TODO_COMPLETE: 'NOTICE_TODO_COMPLETE',
    VIEW_OUTSOURCE_DETAIL: 'VIEW_OUTSOURCE_DETAIL',
    LOAD_OUTSOURCE_DETAIL: 'LOAD_OUTSOURCE_DETAIL',

    TODO_COUNT_UPDATE: 'TODO_COUNT_UPDATE',
    INTERVIEW_CHAT_COUNT_UPDATE: 'INTERVIEW_CHAT_COUNT_UPDATE',
    /**
     * action-点击提交按钮触发返回主视图
     */
    TASK_ACTION_BACK: 'TASK_ACTION_BACK',
    /**
         * action-点击提交按钮触发自动发送记录
         */
    TASK_ACTION_SUBMIT: 'TASK_ACTION_SUBMIT',


    /**
     * wbs-创建工作单元
     */
    WBS_CREATE: 'WBS_CREATE',

    /**
     * wbs-创建工作单元完毕
     */
    WBS_CREATE_FINISH: 'WBS_CREATE_FINISH',

    /**
    * wbs-文件树的文件夹重名信号
    */
    WBS_DELETE_TREE: 'WBS_DELETE_TREE',


    /*目录变化事件*/
    WBS_DIR_CHANGE: 'WBS_DIR_CHANGE',

    /**
     * wbs-文件面板的文件夹重名信号
     */
    WBS_DELETE_MAIN: 'WBS_DELETE_MAIN',

    /**
    * wbs-文件树的文件夹重名信号
    */
    WBS_RENAME_TREE: 'WBS_RENAME_TREE',

    /**
     * wbs-文件面板的文件夹重名信号
     */
    WBS_RENAME_MAIN: 'WBS_RENAME_MAIN',

    /**
     * File-创建文件夹
     */
    FILE_CREATE: 'FILE_CREATE',

    /**
     * File-创建文件夹完毕
     */
    FILE_CREATE_FINISH: 'FILE_CREATE_FINISH',

    /**
     * File-删除文件/文件夹
     */
    FILE_DELETE: 'FILE_DELETE',

    /**
     * File-删除文件/文件夹完毕
     */
    FILE_DELETE_FINISH: 'FILE_DELETE_FINISH',

    /**
    * File-文件树的文件夹重名信号
    */
    FILE_RENAME_TREE: 'FILE_RENAME_TREE',

    /**
     * File-文件面板的文件夹重名信号
     */
    FILE_RENAME_MAIN: 'FILE_RENAME_MAIN',

    /**
     * 发通知
     */
    SEND_NOTICE: 'SEND_NOTICE',
    /**
     * 发任务
     */
    SEND_TASK: 'SEND_TASK',

    /**
     * 报销
     */
    NEW_REIMBURSEMENT: 'NEW_REIMBURSEMENT',
    CREATE_REIMBURSEMENT: 'CREATE_REIMBURSEMENT',

    // 通用信号
    COMMON_DELETE: 'COMMON_DELETE',
    COMMON_CREATE: 'COMMON_CREATE',
    COMMON_UPDATE: 'COMMON_UPDATE',
    COMMON_SELECT: 'COMMON_SELECT',
    COMMON_UPLOAD: "COMMON_UPLOAD",
    COMMON_DOWNLOAD: "COMMON_DOWNLOAD",

    // 会议状态变更
    MEETING_STATUS_UPDATE: 'MEETING_STATUS_UPDATE',

    // 解析简历结束更新简历
    PROFILE_UPDATE: "PROFILE_UPDATE",
    // 项目更新客户
    PROJECT_CUSTOMER_UPDATE: "PROJECT_CUSTOMER_UPDATE",

    /**
     * 文件上传更新信号
     */
    FILE_CHANGE: "FILE_CHANGE",
    /**
     * 文件删除更新信号
     */
    FILE_DROP: "FILE_DROP",
    /**
     * 分享文件数更新信号
     */
    SHARE_NUM_UPDATE: "SHARE_NUM_UPDATE",

    /**
     * 无权限登录
     */
    UN_AUTHORIZED: "UN_AUTHORIZED",

    /**
     * 需要将指定id滚动到视口中
     */
    SCROLL_INTO_VIEW: "SCORLL_INTO_VIEW",
    TASK_ID_UPDATE: "TASK_ID_UPDATE",    //任务id更新
    TASK_DELETED_UPDATE: "TASK_DELETED_UPDATE",  //任务删除的id

    /**
     * 用户反馈更新
     */
    FEEDBACK_UPDATE: "feedback_update",
}

/**
 * 待办完成信号的事件接口
 */
export interface NoticeTodoCompleteEvent {
    entityId?: number,
    entitySheet?: string,
    userId?: number,
    action?: string,
    projectId?: number,
}


export interface WbsPanelEvent {
    isTask?: boolean,
}